var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drag-handle gl-absolute gl-bottom-0 gl-top-0",class:_vm.className,style:(_vm.cursorStyle),on:{"mousedown":_vm.startDrag,"dblclick":_vm.resetSize}},[_vm._t("thumbnail")],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }